import { useCallback } from 'react';
import { useSweepCanvasFitView } from '../../../sweep-canvas/useSweepCanvasFitView';
import { calculateElementsToFit } from './useFitAroundElements';

export const useFocusOnCanvasElements = (funnelMap: FunnelMap) => {
  const { fitAroundNodes } = useSweepCanvasFitView();

  const focusOnCanvasElements = useCallback(
    (elementIds: string[], options = {}, fitAroundFirstStepOnly?: boolean) => {
      if (!elementIds.length || !funnelMap?.funnelsData) return;
      const nodeIds = calculateElementsToFit({
        funnelsData: funnelMap.funnelsData,
        recordTypesData: funnelMap.recordTypesData,
        selectedValues: elementIds,
      });
      fitAroundNodes({
        nodeIds,
        options,
        firstChildNodeOnly: fitAroundFirstStepOnly,
      });
    },
    [fitAroundNodes, funnelMap?.funnelsData, funnelMap?.recordTypesData],
  );

  return focusOnCanvasElements;
};
